import axios from 'axios';
import Resource from './Resource'

export default class NcsTraining extends Resource {
  static ENDPOINT = '/api/ncstraining'

  constructor (args) {
    super(args)
    this.extend(args)
  }

  static create (org) {
    const ncs = {
      org: org,
      ncsSpecials: []
    }
    return new NcsTraining(ncs)
  }
}
